export default "__VITE_ASSET__BCLoMMdj__"